import React, { useState } from 'react';
import { connect } from 'react-redux';

import PromoInputWrapper from 'apps/promo/components/form/PromoInputWrapper';
import { logInfo } from 'apps/promo/helpers/clientLogger';

import { AmountRow } from './styles';
import PromoCountryList from '../CalculatorDropdownNew/PromoCountryList';

const RequestCountryDropbox = (props) => {
    const [isCountryListOpen, setIsCountryListOpen] = useState(false);

    const focus = (e) => {
        if (e.currentTarget) {
            const input = e.currentTarget.firstElementChild;
            input.focus();
        } else {
            logInfo('Focus method not support');
        }
    };

    const toggleCountryList = () => {
        setIsCountryListOpen(!isCountryListOpen);
    };

    const findTargetCountryName = () => {
        const countryName = props.calculatorData.countries.find((country) => country.code === props.country);
        return countryName ? countryName.name : '';
    };

    return (
        <AmountRow onClick={toggleCountryList}>
            {isCountryListOpen ? (
                <PromoCountryList
                    toggleCountryList={toggleCountryList}
                    country={props.country}
                    onDropdownChange={props.onDropdownChange}
                    role={props.role}
                    showCurrencies={false}
                    isRequest
                />
            ) : (
                <PromoInputWrapper name={'requestInput'} isPseudoSelect labelText={props.labelText} isFilled setFocus={focus}>
                    <input value={findTargetCountryName()} type={'text'} autoComplete="off" readOnly id={'requestInput'} />
                </PromoInputWrapper>
            )}
        </AmountRow>
    );
};

const mapStateToProps = ({ app, language, extra }, ownProps) => {
    const { calculator: calculatorData, ...landingPageData } = extra.strapiApi;

    return {
        calculatorData,
        landingPageData,
        countryCode: app.country,
        languageCode: language.lang,
        ...ownProps,
    };
};

export default connect(mapStateToProps)(RequestCountryDropbox);
